export default __webpack_public_path__ + "static/media/sideYellow_diffuse-min.3270a531.jpg";